import React from 'react';
import { SignalRContext } from './SignalRContext';
import useSignalRConnection from './useSignalRConnection';

/**
 * @typedef {object} SignarRProviderProps
 * @property {*} [children]
 */

/**
 * @param {SignarRProviderProps} props
 */
const SignarRProvider = props => {
  const signalRConnection = useSignalRConnection();
  return (
    <SignalRContext.Provider value={signalRConnection}>{props.children}</SignalRContext.Provider>
  );
};

export default SignarRProvider;
